// this page is for edit the doc
import {useParams} from "react-router-dom";

export default function DocEdit() {
    const {docId} = useParams();
}